(function () {
  var STORAGE_KEY = 'wishlistVariants';
  var renderTimer = null;
  var renderToken = 0;
  var rendering = false;

  function readList() {
    try {
      return sanitize(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
    } catch (error) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      // Safari in private mode can refuse localStorage.
    }
  }

  function sanitize(list) {
    if (!Array.isArray(list)) return [];
    var seen = new Object(null);
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var item = normalizeItem(list[i]);
      if (!item || seen[item.variantId]) continue;
      seen[item.variantId] = true;
      out.push(item);
    }
    return out;
  }

  function normalizeItem(item) {
    if (!item || typeof item !== 'object') return null;
    var variantId = Number(item.variantId);
    var productId = Number(item.productId);
    var handle = typeof item.handle === 'string' ? item.handle : '';
    if (!variantId || !productId || !handle) return null;
    return { variantId: variantId, productId: productId, handle: handle };
  }

  function listKey(list) {
    return list.map(function (item) {
      return item.variantId;
    }).sort(function (a, b) {
      return a - b;
    }).join(',');
  }

  // Single write path. A future account sync can listen for wishlist:updated.
  function commit(list) {
    var next = sanitize(list);
    writeList(next);
    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: { items: next }
    }));
  }

  function hasVariant(variantId, list) {
    variantId = Number(variantId);
    list = list || readList();
    for (var i = 0; i < list.length; i++) {
      if (list[i].variantId === variantId) return true;
    }
    return false;
  }

  function hasProduct(productId, list) {
    productId = Number(productId);
    list = list || readList();
    for (var i = 0; i < list.length; i++) {
      if (list[i].productId === productId) return true;
    }
    return false;
  }

  function addItem(item) {
    item = normalizeItem(item);
    if (!item || hasVariant(item.variantId)) return false;
    var list = readList();
    list.unshift(item);
    commit(list);
    return true;
  }

  function toggleVariant(item) {
    item = normalizeItem(item);
    if (!item) return false;
    var list = readList();
    var index = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].variantId === item.variantId) {
        index = i;
        break;
      }
    }
    if (index >= 0) list.splice(index, 1);
    else list.unshift(item);
    commit(list);
    return index < 0;
  }

  function removeProduct(productId) {
    productId = Number(productId);
    if (!productId) return;
    commit(readList().filter(function (item) {
      return item.productId !== productId;
    }));
  }

  function numericVariantId(value) {
    var id = Number(value);
    return id > 0 ? id : 0;
  }

  function variantIdFor(button) {
    if (button.getAttribute('data-wishlist-scope') !== 'variant' || button.closest('[data-wishlist-page]')) {
      return numericVariantId(button.getAttribute('data-variant-id'));
    }

    var fromDrawer = drawerVariantId(button);
    if (fromDrawer) {
      button.setAttribute('data-variant-id', String(fromDrawer));
      return fromDrawer;
    }

    var fromAttribute = numericVariantId(button.getAttribute('data-variant-id'));
    if (fromAttribute) return fromAttribute;

    var root = button.closest('section-product, .ProductQuickview, section-featured-product');
    var select = root && root.querySelector('select[name="id"]');
    var fromSelect = select ? numericVariantId(select.value) : 0;
    if (fromSelect) {
      button.setAttribute('data-variant-id', String(fromSelect));
      return fromSelect;
    }
    return numericVariantId(button.getAttribute('data-fallback-variant-id'));
  }

  function drawerForButton(button) {
    var root = button.closest('[data-section-id]');
    if (!root) return null;
    return document.getElementById('SizePickerDrawer-' + root.getAttribute('data-section-id'));
  }

  function drawerVariantId(button) {
    var drawer = drawerForButton(button);
    if (!drawer) return 0;
    var checked = drawer.querySelector('[data-size-tier]:checked');
    return checked ? numericVariantId(checked.value) : 0;
  }

  function paintButton(button, list) {
    var scope = button.getAttribute('data-wishlist-scope');
    var active = scope === 'product'
      ? hasProduct(button.getAttribute('data-product-id'), list)
      : hasVariant(variantIdFor(button), list);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active ? button.getAttribute('data-label-remove') : button.getAttribute('data-label-add');
    if (label) button.setAttribute('aria-label', label);
  }

  function paintHearts() {
    var list = readList();
    var buttons = document.querySelectorAll('[data-wishlist-button]');
    for (var i = 0; i < buttons.length; i++) paintButton(buttons[i], list);
  }

  function updateCount() {
    var count = readList().length;
    var nodes = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      var bubble = nodes[i].closest('[data-wishlist-bubble]');
      nodes[i].textContent = count > 0 && count < 100 ? String(count) : '';
      if (bubble) bubble.classList.toggle('Visible', count > 0);
    }
  }

  function pop(button) {
    button.classList.remove('is-pop');
    void button.offsetWidth;
    button.classList.add('is-pop');
    window.clearTimeout(button.wishlistPopTimer);
    button.wishlistPopTimer = window.setTimeout(function () {
      button.classList.remove('is-pop');
    }, 400);
  }

  function onButton(button) {
    var productId = Number(button.getAttribute('data-product-id'));
    var handle = button.getAttribute('data-product-handle');
    if (button.getAttribute('data-wishlist-scope') === 'product') {
      if (!productId) return;
      pop(button);
      if (hasProduct(productId)) {
        removeProduct(productId);
        return;
      }
      addItem({
        variantId: Number(button.getAttribute('data-variant-id')),
        productId: productId,
        handle: handle
      });
      return;
    }

    var item = normalizeItem({
      variantId: variantIdFor(button),
      productId: productId,
      handle: handle
    });
    if (!item) return;
    pop(button);
    toggleVariant(item);
  }

  function setVariantButton(button, variantId) {
    if (!button) return;
    if (variantId) button.setAttribute('data-variant-id', String(variantId));
    else button.removeAttribute('data-variant-id');
    paintButton(button, readList());
  }

  function onVariantChanged(event) {
    var variant = event.detail && event.detail.variant;
    var root = event.target;
    if (!root || !root.querySelector) return;
    setVariantButton(
      root.querySelector('[data-wishlist-button][data-wishlist-scope="variant"]'),
      variant && Number(variant.id)
    );
  }

  function buttonForSection(sectionId) {
    if (!sectionId) return null;
    var nodes = document.querySelectorAll('[data-section-id]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-section-id') !== String(sectionId)) continue;
      var button = nodes[i].querySelector('[data-wishlist-button][data-wishlist-scope="variant"]');
      if (button) return button;
    }
    return null;
  }

  // The size drawer keeps the chosen variant to itself until add-to-cart.
  // The heart has to follow that choice, not only variant:changed.
  function applyDrawerVariant(drawer) {
    if (!drawer || !drawer.id || drawer.id.indexOf('SizePickerDrawer-') !== 0) return;
    var sectionId = drawer.id.slice('SizePickerDrawer-'.length);
    var checked = drawer.querySelector('[data-size-tier]:checked');
    var variantId = checked ? Number(checked.value) : 0;
    setVariantButton(buttonForSection(sectionId), variantId);
  }

  function chunk(list, size) {
    var chunks = [];
    for (var i = 0; i < list.length; i += size) chunks.push(list.slice(i, i + size));
    return chunks;
  }

  function fetchChunk(sectionId, ids) {
    var query = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var url = window.routes.searchUrl + '?section_id=' + encodeURIComponent(sectionId) + '&type=product&q=' + encodeURIComponent(query);
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) return null;
      return response.text();
    }).then(function (html) {
      if (!html) return null;
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var dataEl = temp.querySelector('[data-wishlist-products]');
      if (!dataEl) return null;
      var products = JSON.parse(dataEl.textContent || '[]');
      var map = new Object(null);
      for (var i = 0; i < products.length; i++) map[products[i].id] = products[i];
      var cards = temp.querySelectorAll('[data-wishlist-product-card]');
      for (var c = 0; c < cards.length; c++) {
        var productId = cards[c].getAttribute('data-wishlist-product-card');
        if (map[productId]) map[productId].cardHtml = cards[c].outerHTML;
      }
      return map;
    }).catch(function () {
      return null;
    });
  }

  function renderPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root || rendering) return;
    var list = readList();
    var empty = root.querySelector('[data-wishlist-empty]');
    var grid = root.querySelector('[data-wishlist-grid]');
    var error = root.querySelector('[data-wishlist-error]');
    if (!list.length) {
      if (empty) empty.hidden = false;
      if (grid) grid.innerHTML = '';
      if (error) error.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    rendering = true;
    var token = ++renderToken;
    var capturedKey = listKey(list);
    var ids = [];
    var seen = new Object(null);
    for (var i = 0; i < list.length; i++) {
      if (seen[list[i].productId]) continue;
      seen[list[i].productId] = true;
      ids.push(list[i].productId);
    }
    var sectionId = root.getAttribute('data-section-id');
    Promise.all(chunk(ids, 20).map(function (part) {
      return fetchChunk(sectionId, part);
    })).then(function (parts) {
      if (token !== renderToken) {
        rendering = false;
        return;
      }
      if (listKey(readList()) !== capturedKey) {
        rendering = false;
        scheduleRender();
        return;
      }
      if (parts.indexOf(null) !== -1) {
        if (error) error.hidden = false;
        rendering = false;
        return;
      }
      if (error) error.hidden = true;
      var products = new Object(null);
      var foundAny = false;
      for (var p = 0; p < parts.length; p++) {
        var part = parts[p];
        for (var key in part) if (Object.prototype.hasOwnProperty.call(part, key)) {
          products[key] = part[key];
          foundAny = true;
        }
      }
      if (!foundAny) {
        if (error) error.hidden = false;
        rendering = false;
        return;
      }
      var kept = [];
      for (var n = 0; n < list.length; n++) {
        var item = list[n];
        var product = products[item.productId];
        var variant = null;
        if (product && product.variants) {
          for (var v = 0; v < product.variants.length; v++) {
            if (Number(product.variants[v].id) === item.variantId) variant = product.variants[v];
          }
        }
        if (!product || !variant) continue;
        kept.push({ item: item, product: product, variant: variant });
      }
      if (listKey(readList()) !== capturedKey) {
        rendering = false;
        scheduleRender();
        return;
      }
      if (kept.length !== list.length) {
        commit(kept.map(function (row) { return row.item; }));
      }
      grid.innerHTML = '';
      for (var c = 0; c < kept.length; c++) {
        var card = buildCard(kept[c]);
        if (card) grid.appendChild(card);
      }
      if (empty) empty.hidden = kept.length > 0;
      paintHearts();
      rendering = false;
    }).catch(function () {
      rendering = false;
      if (error) error.hidden = false;
    });
  }

  function priceNode(className, text) {
    var node = document.createElement('span');
    var decoder = document.createElement('span');
    node.className = className;
    decoder.innerHTML = String(text);
    node.textContent = decoder.textContent;
    return node;
  }

  function applyVariantPrice(card, variant) {
    var list = card.querySelector('.Product__PriceList');
    if (list && variant && variant.price) {
      list.textContent = '';
      if (variant.compareAt) {
        list.appendChild(priceNode('Price Price--saleRegular', variant.compareAt));
        var sale = priceNode('Price Price--sale', '');
        sale.appendChild(priceNode('Price', variant.price));
        list.appendChild(sale);
      } else {
        list.appendChild(priceNode('Price', variant.price));
      }
    }
    var badge = card.querySelector('.ProductCard__Label--onSale');
    if (!(variant && variant.compareAt) && badge) {
      badge.remove();
    }
  }

  function buildCard(row) {
    if (!row.product.cardHtml) return null;
    var holder = document.createElement('div');
    holder.innerHTML = row.product.cardHtml;
    var card = holder.firstElementChild;
    if (!card) return null;
    var url = row.variant.url || row.product.url;
    var imageLink = card.querySelector('.ProductCard__ImageWrapper > a');
    var titleLink = card.querySelector('.ProductCard__Title a');
    if (imageLink) imageLink.href = url;
    if (titleLink) titleLink.href = url;
    applyVariantPrice(card, row.variant);
    return card;
  }

  function scheduleRender() {
    if (!document.querySelector('[data-wishlist-page]')) return;
    clearTimeout(renderTimer);
    renderTimer = setTimeout(renderPage, 30);
  }

  function addToCart(button) {
    var id = Number(button.getAttribute('data-variant-id'));
    if (!id) return;
    button.disabled = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.disabled = false;
      if (!response.ok) return;
      if (!window.theme.useAjaxCart) {
        window.location.href = window.routes.cartUrl;
        return;
      }
      button.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { quantity: 1 }
      }));
    }).catch(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.disabled = false;
    });
  }

  function bind() {
    document.addEventListener('click', function (event) {
      var add = event.target.closest('[data-wishlist-add]');
      if (add) {
        event.preventDefault();
        addToCart(add);
        return;
      }
      var button = event.target.closest('[data-wishlist-button]');
      if (button) {
        event.preventDefault();
        event.stopPropagation();
        onButton(button);
      }
    });

    document.addEventListener('variant:changed', onVariantChanged);

    document.addEventListener('sizepicker:variant', function (event) {
      var detail = event.detail || {};
      setVariantButton(buttonForSection(detail.sectionId), numericVariantId(detail.variantId));
    });

    document.addEventListener('change', function (event) {
      var tier = event.target.closest && event.target.closest('[data-size-tier]');
      var drawer = tier && tier.closest('[data-size-picker]');
      if (!drawer && event.target.name && String(event.target.name).indexOf('size-tier-') === 0) {
        drawer = document.getElementById('SizePickerDrawer-' + String(event.target.name).slice('size-tier-'.length));
      }
      if (drawer) applyDrawerVariant(drawer);
    });

    document.addEventListener('click', function (event) {
      var sizeKey = event.target.closest('[data-size-key]');
      if (!sizeKey) return;
      applyDrawerVariant(sizeKey.closest('[data-size-picker]'));
    });

    document.addEventListener('wishlist:updated', function () {
      paintHearts();
      updateCount();
      if (!rendering) scheduleRender();
    });

    var paintTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(paintTimer);
      paintTimer = setTimeout(paintHearts, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    bind();
    paintHearts();
    updateCount();
    scheduleRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Wishlist = {
    getAll: readList,
    has: hasVariant,
    hasProduct: hasProduct,
    toggle: toggleVariant,
    add: addItem,
    removeProduct: removeProduct
  };
})();
